var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { isEmptyObject, isUndef, jointParamsToStr } from '@autobest-ui/utils';
/**
 * 当有请求参数时，把参数合并到URL上， 这里提供了url带参数的写法
 * 如：/user/:id/info -> /user/xxx/info
 * @param url
 * @param params
 */
export default function combineParamsToUrl(url, params) {
  if (isEmptyObject(params)) {
    return {
      url: url,
      surplusParams: {}
    };
  }
  // 匹配url中带参数的情况，并删除已匹配的param
  var matchUrlArgs = url.match(/:([^\/]*)/g);
  if (matchUrlArgs && matchUrlArgs.length) {
    var copyParams_1 = __assign({}, params);
    var key_1;
    var param_1;
    matchUrlArgs.forEach(function (arg) {
      key_1 = arg.substr(1);
      param_1 = copyParams_1[key_1];
      if (!isUndef(param_1)) {
        url = url.replace(arg, encodeURIComponent(param_1));
        delete copyParams_1[key_1];
      }
    });
    return {
      url: jointParamsToStr(copyParams_1, url),
      surplusParams: copyParams_1
    };
  }
  return {
    url: jointParamsToStr(params, url),
    surplusParams: params
  };
}